import React from 'react'
import ScreenWrapper from '~/components/screen_wrappers/screen_wrapper'
import MemberForm from './components/member_form'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { useNavigate } from 'react-router-dom'
import { getResourceAuthorization } from '@verzekeringapp-mono/shared/src/state/selectors/resource_authorization'
import useUser from '@verzekeringapp-mono/shared/src/hooks/use_user'

const InviteMemberScreen = () => {
  const resourceAuthorization = useAppSelector(getResourceAuthorization)
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)
  const { inviteUser } = useUser()

  return (
    <ScreenWrapper>
      <MemberForm
        formType='create'
        error={error}
        isLoading={isLoading}
        onSubmit={async ({
          email
        }) => {
          if (!resourceAuthorization?.relationNumber) {
            return
          }

          setIsLoading(true)

          inviteUser(
            resourceAuthorization?.relationNumber,
            email
          )
            .then(() => {
              navigate('/mijn-profiel/gebruikers-beheren')
            })
            .catch(e => {
              setError(e.message)
            })
            .finally(() => {
              setIsLoading(false)
            })
        }}
      />
    </ScreenWrapper>
  )
}

export default InviteMemberScreen
